"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _lodash2 = _interopRequireDefault(require("lodash.debounce"));

var _unique = _interopRequireDefault(require("../../helpers/unique.id"));

var _getNativeProps = _interopRequireDefault(require("../../helpers/get-native-props"));

var _feedback = _interopRequireDefault(require("./subComponents/feedback"));

var _hint = _interopRequireDefault(require("./subComponents/hint"));

var _fieldLabel = _interopRequireDefault(require("./subComponents/fieldLabel"));

var _icon = _interopRequireDefault(require("../../Icon/icon"));

var _deprecatedProp = _interopRequireDefault(require("../../helpers/deprecated-prop"));

var _ui = require("../../../constants/ui.messages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VALIDATION_DELAY = 800;

var Field =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field(props) {
    var _this;

    _classCallCheck(this, Field);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Field).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "initValidation", function () {
      // Calling `onValidationChange` when the component is mounted guarantees
      // Forms know the field exists and its initial validation state without
      // having to trigger an explicit onChange on the children neither rendering
      // the validation error messages.
      // Does not update Field's validity state.
      // The parent Form knows about the Field, with its validity, but validation
      // feedback is not rendered
      var children = _this.props.children;

      _react.default.Children.map(children, function (child) {
        var _child$props = child.props,
            defaultValue = _child$props.defaultValue,
            value = _child$props.value;
        var targetValue = value || defaultValue;

        var validity = _this.runValidationPredicates(targetValue).isValid;

        _this.props.onValidationChange(_this.state.validationId, validity);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initValidationWithRenderMessages", function () {
      // Calling `validate` when the component will mount is done
      // to allow for the first rendering with the page with the
      // validation messages already in place
      // Updates the Field's validity state.
      // The parent Form knows about the Field, with its validity,
      // and validation feedback is rendered.
      var children = _this.props.children;

      _react.default.Children.map(children, function (child) {
        var _child$props2 = child.props,
            defaultValue = _child$props2.defaultValue,
            value = _child$props2.value;
        var targetValue = value || defaultValue;

        _this.validate(targetValue);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addImmediateValidation", function (fn) {
      return _this.addValidation(fn, _this.validate);
    });

    _defineProperty(_assertThisInitialized(_this), "addDebouncedValidation", function (fn) {
      return _this.addValidation(fn, _this.debouncedValidate, !!fn);
    });

    _defineProperty(_assertThisInitialized(_this), "addValidation", function (fn, validationFn, persistEvent) {
      var maxLength = _this.props.maxLength;
      return function (event) {
        var value = event.target.value;
        var charsLeft = maxLength ? maxLength - value.length : undefined;

        if (persistEvent && event.persist) {
          event.persist();
        }

        _this.setState({
          charsLeft: charsLeft
        });

        var updatedvalidity = validationFn(value);

        if (_this.props.preventChangeOnValidationError && !updatedvalidity.custom || !fn) {
          return;
        }

        fn(event);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "hasValue", function (value) {
      return !(0, _lodash.default)(value) || typeof value === 'number' || !!value;
    });

    _defineProperty(_assertThisInitialized(_this), "validateRequired", function (value) {
      return {
        validation: 'required',
        value: _this.props.required ? _this.hasValue(value) : true
      };
    });

    _defineProperty(_assertThisInitialized(_this), "validateCustom", function (value) {
      return {
        validation: 'custom',
        value: _this.props.onValidate(value instanceof Array ? value.slice(-1)[0] : value)
      };
    });

    _defineProperty(_assertThisInitialized(_this), "runValidationPredicates", function (value) {
      var predicates = [_this.validateRequired, _this.validateCustom];
      var result = predicates.reduce(function (validity, predicate) {
        var _objectSpread2;

        if (!validity.isValid) return validity;
        var result = predicate(value);
        var isValid = !!result.value;
        return _objectSpread({}, validity, (_objectSpread2 = {}, _defineProperty(_objectSpread2, result.validation, isValid), _defineProperty(_objectSpread2, "isValid", isValid), _objectSpread2));
      }, _objectSpread({}, _this.state.validity, {
        isValid: true
      }));
      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "validate", function (value) {
      var updatedValidity = _this.runValidationPredicates(value);

      if (updatedValidity.custom !== _this.state.validity.custom || updatedValidity.required !== _this.state.validity.required) {
        _this.setState({
          validity: updatedValidity
        }, function () {
          var _this$state = _this.state,
              validationId = _this$state.validationId,
              validity = _this$state.validity;

          _this.props.onValidationChange(validationId, validity.isValid);
        });
      }

      return updatedValidity;
    });

    _defineProperty(_assertThisInitialized(_this), "isValid", function () {
      var isValid = _this.state.validity.isValid;
      return isValid === undefined || isValid;
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (id) {
      var _this$props = _this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          required = _this$props.required,
          maxLength = _this$props.maxLength;
      return _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          id: id,
          disabled: disabled,
          required: required,
          maxLength: maxLength,
          onChange: _this.props.immediateValidation ? _this.addImmediateValidation(child.props.onChange) : _this.addDebouncedValidation(child.props.onChange),
          onBlur: _this.props.immediateValidation ? _this.addImmediateValidation(child.props.onBlur) : _this.addDebouncedValidation(child.props.onBlur)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderValidationMessage", function () {
      if (_this.isValid()) return;
      var validity = _this.state.validity;
      var requiredMessage = _this.props.validationMessages.required || _ui.REQUIRED_ERROR_FEEDBACK;
      var customValidationMessage = _this.props.validationMessages.custom || _this.props.validationMessage; // Second expression is deprecated

      var validationMessage = !validity.required ? requiredMessage : customValidationMessage;
      return _react.default.createElement(_feedback.default, null, _react.default.createElement(_icon.default, {
        name: _icon.default.INFO_OUTLINE,
        tiny: true
      }), validationMessage);
    });

    var _child = _react.default.Children.only(props.children);

    var _value = _child.props.value || _child.props.defaultValue || '';

    var _charsLeft = _this.props.maxLength ? _this.props.maxLength - _value.length : undefined;

    _this.state = {
      validity: {
        isValid: undefined,
        required: undefined,
        custom: undefined
      },
      validationId: (0, _unique.default)(),
      charsLeft: _charsLeft
    };
    _this.debouncedValidate = (0, _lodash2.default)(_this.validate, VALIDATION_DELAY);
    return _this;
  }

  _createClass(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.renderValidationOnMount) {
        this.initValidation();
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.renderValidationOnMount) {
        this.initValidationWithRenderMessages();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Must cancel all debounced validations when component unmounts or else memory leaks
      this.debouncedValidate.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          hint = _this$props2.hint,
          topHint = _this$props2.topHint,
          smallLabel = _this$props2.smallLabel,
          largeLabel = _this$props2.largeLabel,
          props = _objectWithoutProperties(_this$props2, ["label", "hint", "topHint", "smallLabel", "largeLabel"]);

      var charsLeft = this.state.charsLeft;
      var id = this.props.id || this.state.validationId;
      var isValid = this.isValid();
      var styles = (0, _classnames.default)('co-form__field', {
        'co--error': !isValid
      });

      var processedLabel = _react.default.createElement(_fieldLabel.default, _extends({}, this.props, {
        htmlFor: id,
        charsLeft: charsLeft,
        small: smallLabel,
        large: largeLabel
      }), label);

      return _react.default.createElement("div", _extends({
        className: styles
      }, (0, _getNativeProps.default)(props)), label ? processedLabel : null, topHint ? _react.default.createElement(_hint.default, null, topHint) : null, this.renderChildren(id), this.renderValidationMessage(), hint ? _react.default.createElement(_hint.default, null, hint) : null);
    }
  }]);

  return Field;
}(_react.default.Component);

var hintsValidation = (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes.string, 'hint', 'topHint');
var labelSizesExclusives = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('smallLabel', 'largeLabel');
Field.propTypes = {
  children: _propTypes.element.isRequired,
  id: _propTypes.string,
  label: _propTypes.string,
  hint: hintsValidation,
  topHint: hintsValidation,
  secondaryLabel: _propTypes.node,
  tertiaryLabel: _propTypes.node,

  /** {bool} Mutually exclusive props: @@smallLabel@@ @@largeLabel@@ */
  smallLabel: labelSizesExclusives,

  /** {bool} Mutually exclusive props: @@smallLabel@@ @@largeLabel@@ */
  largeLabel: labelSizesExclusives,
  disabled: _propTypes.bool,
  required: _propTypes.bool,
  maxLength: _propTypes.number,

  /** @@!!!@@ Use @@validationMessages@@ object prop instead. */
  validationMessage: (0, _deprecatedProp.default)(_propTypes.string, 'Deprecated'),

  /** {object} Object with shape {required: string, custom: string}. Values are the messages to be displayed after required and custom validations fail. */
  validationMessages: (0, _propTypes.shape)({
    required: _propTypes.string,
    custom: _propTypes.string
  }),
  onValidationChange: _propTypes.func,

  /** Callback that runs custom validation for the child input. This function must receive a string value as argument. */
  onValidate: _propTypes.func,
  renderValidationOnMount: _propTypes.bool,
  preventChangeOnValidationError: _propTypes.bool,
  immediateValidation: _propTypes.bool
};

var noop = function noop() {
  return true;
};

Field.defaultProps = {
  onValidate: noop,
  onValidationChange: function onValidationChange(value) {
    return true;
  },
  validationMessages: {}
};
Field.VALIDATION_DELAY = VALIDATION_DELAY;
var _default = Field;
exports.default = _default;
Field.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "initValidation",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "initValidationWithRenderMessages",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "addImmediateValidation",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "fn",
      "type": null
    }],
    "returns": null
  }, {
    "name": "addDebouncedValidation",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "fn",
      "type": null
    }],
    "returns": null
  }, {
    "name": "addValidation",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "fn",
      "type": null
    }, {
      "name": "validationFn",
      "type": null
    }, {
      "name": "persistEvent",
      "type": null
    }],
    "returns": null
  }, {
    "name": "hasValue",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "validateRequired",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "validateCustom",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "runValidationPredicates",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "validate",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "isValid",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderChildren",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderValidationMessage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Field",
  "props": {
    "onValidate": {
      "defaultValue": {
        "value": "() => true",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback that runs custom validation for the child input. This function must receive a string value as argument."
    },
    "onValidationChange": {
      "defaultValue": {
        "value": "(value) => true",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "validationMessages": {
      "defaultValue": {
        "value": "{ }",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "string",
            "required": false
          },
          "custom": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "{object} Object with shape {required: string, custom: string}. Values are the messages to be displayed after required and custom validations fail."
    },
    "children": {
      "type": {
        "name": "element"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "hint": {
      "type": {
        "name": "custom",
        "raw": "hintsValidation"
      },
      "required": false,
      "description": ""
    },
    "topHint": {
      "type": {
        "name": "custom",
        "raw": "hintsValidation"
      },
      "required": false,
      "description": ""
    },
    "secondaryLabel": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "tertiaryLabel": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "smallLabel": {
      "type": {
        "name": "custom",
        "raw": "labelSizesExclusives"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@smallLabel@@ @@largeLabel@@"
    },
    "largeLabel": {
      "type": {
        "name": "custom",
        "raw": "labelSizesExclusives"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@smallLabel@@ @@largeLabel@@"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "maxLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "validationMessage": {
      "type": {
        "name": "custom",
        "raw": "deprecated(string, 'Deprecated')"
      },
      "required": false,
      "description": "@@!!!@@ Use @@validationMessages@@ object prop instead."
    },
    "renderValidationOnMount": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "preventChangeOnValidationError": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "immediateValidation": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};